import React, {
  useEffect,
  useRef,
  useState,
  Suspense,
  lazy,
  useMemo,
} from "react";
import { Grid, Tooltip, Typography } from "@mui/material";
import axios from "axios";
import Layout from "../../../layout/Layout";
import { config, positionMasterAPI } from "../../../config";
import { AddPosition } from "../../../components/AddPosition";
import NotFound from "../../../components/NotFount";
import { Create } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";
import AddIcon from "@mui/icons-material/Add";
import DataTable from "react-data-table-component";
import EditLocationOutlinedIcon from "@mui/icons-material/EditLocationOutlined";
import IconButton from "@mui/material/IconButton";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { MaterialReactTable } from "material-react-table";

let field = "id",
  orderBy = "desc";

const Pagination = lazy(() => import("../../../components/ReactPagination"));

function AddRoleMaster() {
  const navigate = useNavigate();

  let intOffset = 0;
  const limit = 10;
  const [totalCount, setTotalCount] = useState(0);
  const [positionMasterList, setpositionMasterList] = useState([]);

  const handleReportPagination = (e) => {
    intOffset =
      e.target.innerText === "1"
        ? 0
        : (parseInt(e.target.innerText) - 1) * limit;
  };

  let assetsRef = useRef(false);
  const childRef = useRef();

  // useEffect(function () {
  //   if (assetsRef.current === false) {
  //     fetchData(1);
  //     return () => {
  //       assetsRef.current = true;
  //     };
  //   }
  // }, []);

  const handleEditPositions = (
    id,
    Role,
    positionName,
    department_id,
    Status
  ) => {
    childRef.current.setData(
      JSON.stringify({
        intPositionID: id,
        intRoleID: Role,
        positionName: positionName,
        intDepartmentID: department_id,
        status: Status,
        intType: 3,
      })
    );
  };

  const handleDeletedepartments = async (id) => {
    const confirm = window.confirm("Are you sure want to delete this?");
    if (!confirm) return;
    const data = JSON.stringify({
      intPositionID: id,
      intType: 6,
    });

    config.method = "POST";
    config.data = data;
    config.url = positionMasterAPI;

    axios(config)
      .then(function (response) {
        window.location.reload(false);
        alert("Position Deleted");

        // fetchUsers(1);
      })
      .catch(function (error) {
        console.log(error);
        childRef.current.triggerAlert(
          JSON.stringify({
            message: error.data.message,
            messageType: "error",
          })
        );
      });
  };

  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10); //change to 10 after you remove paginationRowsPerPageOptions
  const [currentPage, setCurrentPage] = useState(1);

  let tempRefs = useRef(false);
  useEffect(() => {
    if (tempRefs.current === false) {
      fetchUsers(1);
    }
  }, []);

  const fetchUsers = async (page, rowsPerPage) => {
    if (tempRefs.current === false) {
      const data = JSON.stringify({
        intLimit: rowsPerPage ? rowsPerPage : 10,
        intOffset: rowsPerPage ? (page - 1) * rowsPerPage : 0,
        intType: 7,
      });

      config.method = "POST";
      config.data = data;
      config.url = positionMasterAPI;

      axios(config)
        .then(function (response) {
          setpositionMasterList(response.data["result"]);
          setTotalCount(response.data.totalCount);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    tempRefs.current = true;
  };

  const handlePageChange = (page) => {
    tempRefs.current = false;
    fetchUsers(page, rowsPerPage);
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = async (newRowsPerPage) => {
    if (!positionMasterList.length) return; //when the table is rendered for the first time, this would trigger, and we don't need to call fetchUsers again

    tempRefs.current = false;
    fetchUsers(1, newRowsPerPage);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  const handleSort = (column, sortDirection) => {
    setLoading(true);
    setTimeout(() => {
      field = column.field;
      orderBy = sortDirection;
      fetchUsers(1);
      setLoading(false);
    }, 100);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "position_name",
        header: "Position Name",
        size: 150, // width in pixels (20% of ~750px total)
        enableSorting: true,
      },
      {
        accessorKey: "department_name",
        header: "Department Name",
        size: 190, // ~25%
        enableSorting: true,
      },
      {
        accessorKey: "role_name",
        header: "Role Name",
        size: 110, // ~15%
        enableSorting: true,
      },
      {
        accessorKey: "status_name",
        header: "Status",
        Cell: ({ cell }) => (
          <Typography
            className={`${
              cell.getValue() === "Active" ? "active-status" : "inactive-status"
            }`}
          >
            {cell.getValue()}
          </Typography>
        ),
        size: 100,
      },
      {
        header: "Action",
        size: 100,
        Cell: ({ row }) => (
          <Tooltip title="Edit position" arrow>
            <IconButton
              color="success"
              onClick={() =>
                handleEditPositions(
                  row.original.id,
                  row.original.role_id,
                  row.original.position_name,
                  row.original.department_id,
                  row.original.status
                )
              }
              aria-label="edit position"
            >
              <EditLocationOutlinedIcon />
            </IconButton>
          </Tooltip>
        ),
        enableSorting: false,
      },
    ],
    []
  );

  const fetchData = (action) => {
    if (action === 1) {
      intOffset = 0;
    }
  };

  return (
    <Layout>
      <Grid className="employee-form bold-header">
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Position Master
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">Position</Typography>
              <Typography color="text.primary">Add</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid
            textAlign="right"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <LoadingButton
              size="medium"
              variant="contained"
              color="success"
              className="button_first"
              href="/config/departments-master"
              startIcon={<AddIcon />}
            >
              Add Department
            </LoadingButton>
            <LoadingButton
              size="medium"
              variant="contained"
              color="primary"
              onClick={() => navigate(-1)}
              startIcon={<ArrowBackIosIcon />}
            >
              Back
            </LoadingButton>
          </Grid>
        </Grid>
        <Grid className="form_design">
          <AddPosition ref={childRef} fetchData={fetchData} />
          <div className="empty-space-20"></div>
          <Grid className="small_table">
            <MaterialReactTable
              columns={columns}
              enableGlobalFilter={false}
              // enableColumnActions={false}
              enableFullScreenToggle={false}
              enableDensityToggle={false}
              data={positionMasterList}
              state={{
                isLoading: loading,
                pagination: {
                  pageIndex: currentPage - 1, // MRT uses zero-based index
                  pageSize: rowsPerPage,
                },
              }}
              manualPagination
              rowCount={totalCount}
              onPaginationChange={(updater) => {
                const newPagination =
                  typeof updater === "function"
                    ? updater({
                        pageIndex: currentPage - 1,
                        pageSize: rowsPerPage,
                      })
                    : updater;
                handlePageChange(newPagination.pageIndex + 1); // convert back to one-based
                handleRowsPerPageChange(newPagination.pageSize);
              }}
              enableStickyHeader
              muiTableHeadCellProps={{
                sx: {
                  "& input": {
                    color: "#fff !important",
                    "&::placeholder": {
                      color: "#fff !important",
                      opacity: 1,
                    },
                  },
                  "& .MuiSelect-select": {
                    color: "#fff !important", // selected text color
                  },
                  "& .MuiSelect-icon": {
                    color: "#fff !important", // dropdown arrow color
                  },
                  color: "#fff",
                  fontWeight: "bold",
                  "& svg": {
                    color: "#fff",
                  },
                  "& .MuiTableSortLabel-root": {
                    color: "#495057",
                    "&.Mui-active": {
                      color: "#fff",
                      "& .MuiTableSortLabel-icon": {
                        color: "#fff !important",
                      },
                    },
                  },
                  "& .MuiTableSortLabel-icon": {
                    color: "#fff !important",
                  },
                },
              }}
              muiTableContainerProps={{
                sx: { maxHeight: "550px" },
              }}
              muiTablePaperProps={{
                sx: {
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                },
              }}
              initialState={{
                density: "compact",
              }}
              muiTableBodyRowProps={({ row }) => ({
                sx: {
                  cursor: "pointer",
                },
              })}
              pageCount={Math.ceil(totalCount / rowsPerPage)}
              muiTablePaginationProps={{
                rowsPerPageOptions: [1, 10, 25, 50, 100],
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
}

export default AddRoleMaster;
